import { useMemo } from "react"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { useTheme } from "@l2r-front/l2r-ui"
import { useUrlParams } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../../common/constants/i18n"
import { DAMAGES_URL_PREFIX_PARAM, MIRANDA_GRADE_TYPE, NETWORK_ASSESMENT_TYPE_URL_PARAM, NETWORK_GRADING_PREFIX_PARAM } from "../../../common/constants/urlParams"

import { getDamagesLegendConfig } from "../constants/getDamagesConfig"
import { getMirandaLegendConfig, getNotationLegendConfig } from "../constants/getNotationConfig"
import { useRoadwayStateContext } from "../contexts/RoadwayContext"

export function useRoadwayLegend() {

    const { getParam } = useUrlParams()
    const { t } = useTranslation(I18N_NAMESPACE)
    const theme = useTheme()

    const { selectedNetworkYearlyStatus } = useRoadwayStateContext()

    const networkGradingLegend = useMemo(() => getNotationLegendConfig(key => t(I18N_NAMESPACE, key), theme), [t, theme])
    const damagesLegend = useMemo(() => getDamagesLegendConfig(key => t(I18N_NAMESPACE, key), theme), [t, theme])
    const mirandaLegend = useMemo(() => getMirandaLegendConfig(key => t(I18N_NAMESPACE, key), theme), [t, theme])

    const currentNetworkAssesmentType = getParam(NETWORK_ASSESMENT_TYPE_URL_PARAM)?.replace(/-(.*)/, "-") || null
    const currentDamageCode = getParam(NETWORK_ASSESMENT_TYPE_URL_PARAM)?.replace(DAMAGES_URL_PREFIX_PARAM, "") || ""
    const damageTypes = selectedNetworkYearlyStatus?.damageTypes?.find(damageType => {
        return damageType.code === currentDamageCode
    })
    const damagesLabel = damageTypes?.name ?? ""

    switch (currentNetworkAssesmentType) {
        case DAMAGES_URL_PREFIX_PARAM:
            return [
                {
                    layerName: damagesLabel,
                    legendData: damagesLegend,
                    title: t(I18N_NAMESPACE, "containers.damagesLayer.legend.title"),
                },
            ]
        case MIRANDA_GRADE_TYPE:
            return [{
                layerName: t(I18N_NAMESPACE, "containers.mirandaNotationLayer.title"),
                legendData: mirandaLegend,
                title: t(I18N_NAMESPACE, "containers.mirandaNotationLayer.title"),
            }]
        case NETWORK_GRADING_PREFIX_PARAM:
            return [
                {
                    layerName: t(I18N_NAMESPACE, "containers.notationLayer.title"),
                    legendData: networkGradingLegend,
                    title: t(I18N_NAMESPACE, `containers.notationLayer.legend.title.${getParam(NETWORK_ASSESMENT_TYPE_URL_PARAM)}`),
                },
            ]
        default:
            return null
    }
}